import { CoachFilters } from '@/interfaces/filters/coachFilters';
import { Profile } from '@/interfaces/profile';
import { ProfileModule } from '../profile.module';

/**
 * Moduł trenerów
 *
 * @export
 * @class CoachModule
 * @extends {ProfileModule}
 */
export class CoachModule extends ProfileModule {
  public actions = {
    list: (context: any, filters: CoachFilters): Promise<Profile[]> => {
      return this.resource.coachList(filters).then(({ list, count }) => {
        context.commit('saveList', list);
        context.commit('saveCount', count);
        return list;
      });
    }
  };
}

export default new CoachModule();
